module.exports = require("react-dom");


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 4
// module chunks = 0